export const graphProcessorToFileList = (loadedGraph) => {
    return [
        {
            name: "Proba",
            isDirectory: true,
            path: "/Proba",
            updatedAt: "2022-06-28T17:22:45.536Z",
            id: "123",
            node: {},
        },
        {
            name: "Probafájl",
            isDirectory: false,
            path: "/Proba/x",
            updatedAt: "2022-07-28T17:22:45.536Z",
            id: "124",
            node: {},
            size: 1234,
        },
    ];
};
